module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/store_images/1_9aaeeaae89a2287823f5506d457724a5.png";